import { useQuery } from '@tanstack/react-query'
import { notificationsApi } from '../api/notifications'
import type { Language } from './useLanguage'

export function useNotificationUnreadCount() {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: notificationsApi.unreadCount,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export function useNotifications(lang: Language) {
  return useQuery({
    queryKey: ['notifications', 'list', lang],
    queryFn: () => notificationsApi.list(lang),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  })
}
